import { EmailOutlined as EmailOutlinedIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';

const EmailSyncTitle = () => {
  return (
    <Typography
      variant='h4'
      sx={{
        mb: 3,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        '& svg': {
          fontSize: '1.4em',
          position: 'relative',
          top: '1px',
          marginLeft: '2px',
        },
      }}
    >
      <EmailOutlinedIcon />
      Email Sync
    </Typography>
  );
};

export default EmailSyncTitle;
